// BaseInvoiceView Component
/* eslint indent: 0 */

import _ from 'lodash'
import async from 'async'

import app from '../../../app.jsx'

import PageBase from '../../../common/page/page_base/page_base.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import InvoiceUtil from '../../../lib/invoiceutil.js'
import Util from '../../../lib/util.jsx'
import currency from '../../../lib/currency.jsx'

class BaseInvoiceView extends PageBase {
  componentDidMount () {
    this._getData()
    this._initEvents()
  }

  componentWillUnmount () {
    this._releaseEvents()
  }

  /* Event handlers */

  _reloadQuickbookItems () {
    return app
      .service('/api/quickbook/syncitem')
      .create({})
      .then(itemRes => {
        this.data.quickbookItems = itemRes.data || []
        this.setState({ dataDate: new Date() })
      })
      .catch(err => {
        app.debug('PageprojectViewBudget: _reloadQuickbookItems Error', err)
      })
  }

  getContentClassname () {
    return 'alt full'
  }

  onAdd () {
    this.setState({ bShowClose: true })
    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.show()
    }
  }

  onFABClose () {
    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.hide()
    }
    this.setState({ bShowClose: false })
  }

  _reloadData () {
    this._getData()
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  _onIntroAdd (ev) {
    ev.preventDefault()

    if (this.data.invoice.introText === null) {
      this.data.invoice.introText = ''
    }

    this.setState({ bShowClose: false })
    if (this._references.invoiceIntro.current) {
      this._references.invoiceIntro.current.show(true)
    }
    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.hide()
    }
  }

  _onDeleteIntro () {
    if (this.data.invoice !== null) {
      this.data.invoice.introText = null
      this._onIntroChange(null)
    }
    if (this._references.invoiceIntro.current) {
      this._references.invoiceIntro.current.hide()
    }
  }

  _onFABInvoiceViewAddClose () {
    this._hideCloseFABButton()
  }

  _onAddActivity (type, ev) {
    ev.preventDefault()
    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.hide()
    }
    if (this._references.invoiceItemAdd.current) {
      this._references.invoiceItemAdd.current.onAddActivity(type)
    }
    this.setState({ bShowClose: false })
  }

  _onCreateNewActivity (budget, type, phaseId, groupId) {
    const team = app.getTeam()
    let vat =
      team && team.profile && team.profile.vatRate
        ? parseFloat(team.profile.vatRate)
        : 0
    const teamCountry = team && team.profile ? team.profile.country : ''

    const address =
      this.data.invoice && this.data.invoice.contactAddress
        ? this.data.invoice.contactAddress
        : null

    if (teamCountry && address && address.country) {
      let invoiceCountry = address.country
      if (invoiceCountry === 'GB') {
        invoiceCountry = 'UK'
      }

      if (!Util.isEuropeCountry(invoiceCountry)) {
        vat = 0
      } else if (
        teamCountry !== invoiceCountry &&
        Util.isEuropeCountry(invoiceCountry)
      ) {
        vat = 0
      }
    }

    return InvoiceUtil.createNewActivity(budget, type, phaseId, groupId, vat)
  }

  _onEdit () {
    if (this.data.invoice) {
      const invoice = this.data.invoice
      const contact = invoice.contact
      const contactAddresses =
        invoice && contact && contact.addresses ? contact.addresses : null
      const invoiceObj = {
        id: invoice.id,
        referenceNo: invoice.referenceNo ? invoice.referenceNo : '',
        contactName: invoice && contact ? contact.company : '',
        projectTitle: invoice && invoice.project ? invoice.project.title : '',
        addressOptions: this._getContactAddressOptions(invoice),
        addresses: contactAddresses,
        contactPersonOptions: this._getContactPersonOptions(contact),
        contactPerson: invoice.contactPerson
          ? `${invoice.contactPerson.name}${
              invoice.contactPerson.email
                ? ' - ' + invoice.contactPerson.email
                : ''
            }`
          : '',
        contactAddress:
          invoice.contactAddress && invoice.contactAddress.type
            ? invoice.contactAddress
            : contactAddresses
            ? contactAddresses[0]
            : null
      }
      if (this._references.refDialogEditInvoice.current) {
        this._references.refDialogEditInvoice.current.show(invoiceObj)
      }
    }
  }

  _getVatAmount (amount, vat) {
    if (vat && parseFloat(vat) > 0) {
      const vatAmount = parseFloat(amount) * (parseFloat(vat) / 100)
      return currency.round(vatAmount)
    }

    return 0
  }

  _getContactPersonOptions (contact) {
    const contactPersonOptions = []
    if (
      contact &&
      contact.contactPersons &&
      contact.contactPersons.length > 0
    ) {
      contact.contactPersons.map(contactPerson => {
        const label =
          contactPerson.name +
          (contactPerson.email ? ' - ' + contactPerson.email : '')

        contactPersonOptions.push({
          label: label,
          value: label,
          obj: contactPerson
        })
      })
    }

    return contactPersonOptions
  }

  _getContactAddressOptions (invoice) {
    const addressOptions = []
    const contact = invoice.contact
    if (contact && contact.addresses && contact.addresses.length > 0) {
      contact.addresses.map(address => {
        const existTypeOption = _.find(
          addressOptions,
          addressOption => addressOption.label === address.type
        )
        const label = IntlUtil.convertMessage(
          `contact.view.type${address.type}`
        )
        if (existTypeOption === undefined) {
          addressOptions.push({
            label: label,
            value: address.type.toLowerCase()
          })
        }
      })
    }

    if (invoice.contactAddress && addressOptions[0].value === undefined) {
      const label = IntlUtil.convertMessage(
        `contact.view.type${invoice.contactAddress.type}`
      )
      addressOptions.push({
        label: label,
        value: invoice.contactAddress.type.toLowerCase()
      })
    }

    return addressOptions
  }

  _getDataProjectUsers (callback) {
    app.debug('BaseInvoiceView: _getDataProjectUsers [start]')
    const params = {
      query: {
        $client: { userDetail: true },
        projectId: this.data.invoice.projectId
      }
    }

    app
      .service('/api/projectuser')
      .find(params)
      .then(result => {
        if (result && result.total > 0) {
          this.data.projectUsers = []
          result.data.map(projectuser => {
            this.data.projectUsers.push({
              label: projectuser.displayName,
              value: projectuser.userId
            })
          })
        }

        callback(null)
      })
      .catch(err => {
        app.debug('BaseInvoiceView: _getDataProjectUsers err', err)
        callback(err)
      })
  }

  _updateContactAddresses (contactObj, callback) {
    app
      .service('/api/contact')
      .patch(this.data.invoice.contactId, contactObj)
      .then(_contRes => {
        callback(null)
      })
      .catch(contUpdateErr => {
        app.debug('BaseInvoiceView: _updateContactAddresses err', contUpdateErr)
        callback(contUpdateErr)
      })
  }

  /* Api functions */
  onIntroChange (apiName, introText) {
    const updateObj = { introText: introText }

    app
      .service(apiName)
      .patch(this.data.invoice.id, updateObj)
      .then(_introRes => {
        this._refresh()
      })
      .catch(introErr => {
        app.debug('BaseInvoiceView: onIntroChange err', introErr)
      })
  }

  onUpdateInvoiceTotal (apiName, total, totalInc) {
    const updateObj = {
      total: total,
      totalInc: totalInc
    }

    app
      .service(apiName)
      .patch(this.data.invoice.id, updateObj)
      .then(_updateRes => {
        /* Always Reload if total updated */
        this._isDataLoading = false
        this._lastReloadTime = null
      })
      .catch(updateErr => {
        app.debug('BaseInvoiceView: onUpdateInvoiceTotal err', updateErr)
      })
  }

  onChangeBudget (apiName, budgetObj) {
    const saveObj = InvoiceUtil.getSaveObject(budgetObj)

    async.series(
      [
        done => {
          app
            .service(apiName)
            .patch(this.data.invoice.id, { budget: saveObj.budget })
            .then(_invoiceRes => {
              done(null)
            })
            .catch(invoiceErr => {
              done(invoiceErr)
            })
        }
        /* (done) => {
        this._saveInvoiceItems(this.props.invoiceId, saveObj.items, done);
      } */
      ],
      (asynErr, _asyncRes) => {
        if (asynErr) {
          app.debug('BaseInvoiceView: onChangeBudget err', asynErr)
        } else {
          this._lastReloadTime === null //eslint-disable-line
        }
      }
    )
  }

  onSubmitInvoiceEdit (apiName, invoiceObj) {
    const updateObj = {
      referenceNo: invoiceObj.referenceNo ? invoiceObj.referenceNo : '',
      contactAddress: invoiceObj.contactAddress,
      contactPerson: invoiceObj.contactPerson
    }

    app
      .service(apiName)
      .patch(invoiceObj.id, updateObj)
      .then(_editRes => {
        if (this._references.refDialogEditInvoice.current) {
          this._references.refDialogEditInvoice.current.hide()
        }
        this._getDataBudget(() => {
          if (this._references.invoiceViewContent.current) {
            this._references.invoiceViewContent.current.refreshInvoice(
              InvoiceUtil.getRenderObject(this.data.budget, this.data.items)
            )
          }
        })
      })
      .catch(editErr => {
        app.debug('BaseInvoiceView: onSubmitInvoiceEdit err', editErr)
      })
  }

  _updateInvoiceContact (apiName, updateObj, callback) {
    const invoiceObj = {
      contactAddress: updateObj.address
    }

    if (updateObj.selectedContactPerson) {
      invoiceObj.contactPerson = updateObj.selectedContactPerson
    }

    app
      .service(apiName)
      .patch(this.data.invoice.id, invoiceObj)
      .then(_updateRes => {
        callback(null)
      })
      .catch(updateErr => {
        app.debug('BaseInvoiceView: _updateInvoiceContact err', updateErr)
        callback(updateErr)
      })
  }

  onDeleteInvoice (apiName, redirectIdent) {
    if (!this.data.invoice.id) {
      return false
    }

    app
      .service(apiName)
      .remove(this.data.invoice.id)
      .then(_deleteRes => {
        if (this._references.refDialogEditInvoice.current) {
          this._references.refDialogEditInvoice.current.hide()
        }
        app.changePage(redirectIdent)
      })
      .catch(deleteErr => {
        app.debug('BaseInvoiceView onDeleteInvoice err', deleteErr)
      })
  }
}

export default BaseInvoiceView
